import { z } from 'zod';

export const MEDIA_KINDS = ['image', 'video', 'file'] as const;
export type MediaKind = (typeof MEDIA_KINDS)[number];

export const MEDIA_STATUSES = ['processing', 'ready', 'failed'] as const;
export type MediaStatus = (typeof MEDIA_STATUSES)[number];

/** Dimensione massima di un file caricato (4 GB). */
export const MAX_UPLOAD_BYTES = 4 * 1024 * 1024 * 1024;

export interface MediaItem {
  id: string;
  pageId: string;
  kind: MediaKind;
  status: MediaStatus;
  originalName: string;
  mime: string;
  size: number;
  width: number | null;
  height: number | null;
  /** Durata in secondi (solo video). */
  duration: number | null;
  caption: string;
  tags: string[];
  used: boolean;
  /** Messaggio se l'elaborazione non è riuscita del tutto. */
  note: string;
  thumbUrl: string | null;
  previewUrl: string | null;
  originalUrl: string;
  downloadUrl: string;
  createdAt: string;
  updatedAt: string;
}

export const mediaListQuerySchema = z.object({
  pageId: z.string().optional(),
  kind: z.enum(MEDIA_KINDS).optional(),
  used: z.enum(['0', '1']).optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(60),
});
export type MediaListQuery = z.infer<typeof mediaListQuerySchema>;

export const mediaUpdateSchema = z
  .object({
    caption: z.string().trim().max(5000),
    tags: z.array(z.string().trim().min(1).max(40)).max(30),
    used: z.boolean(),
  })
  .partial()
  .refine((v) => Object.keys(v).length > 0, { message: 'Niente da salvare' });
export type MediaUpdateInput = z.infer<typeof mediaUpdateSchema>;

export interface MediaList {
  items: MediaItem[];
  nextCursor: string | null;
  /** Totale dei contenuti con questi filtri. */
  total: number;
}

export function mediaKindFromMime(mime: string): MediaKind {
  if (mime.startsWith('image/')) return 'image';
  if (mime.startsWith('video/')) return 'video';
  return 'file';
}
